module.exports = __webpack_public_path__ + "img/plan.a25466ab.png";